import { Injectable, EventEmitter } from '@angular/core'
import PouchDB from 'pouchdb';
import pouchdbsize from 'pouchdb-size';
import 'rxjs/add/operator/map';
import { M3DevicesService } from 'reglanegocio-grl';


@Injectable({
    providedIn: 'root'
})
export class bdOffLineLog {
    private isInstantiated: boolean;
    private database: any;
    private listener: EventEmitter<any> = new EventEmitter();
    

    constructor(public oM3DevicesService:M3DevicesService) {
        if (!this.isInstantiated) {
            var katios = this.GetIdKatiosLVL1FromSession();
            this.database = new PouchDB("OfflineLog" + katios, { auto_compaction: true });
            this.isInstantiated = true;
        }
    }

    //Idkatios que se carga, cuando se inicia el redireccionamiento hacia el WE8
    public GetIdKatiosLVL1FromSession() {
        var sSessionLVL1M3 = sessionStorage.getItem("SessionLVL1M3");
        var oSessionLVL1M3;
        if (sSessionLVL1M3 !== undefined && sSessionLVL1M3 != null) {
            oSessionLVL1M3 = JSON.parse(sSessionLVL1M3);
            if (oSessionLVL1M3.UsuarioSistema.IDKATIOS !== undefined && oSessionLVL1M3.UsuarioSistema.IDKATIOS != null) {
                return oSessionLVL1M3.UsuarioSistema.IDKATIOS;
            }
        }
        return null;
    }

    public get(id: string) {
        return this.database.get(id);
    }

    //Adicionar en BD pouch.
    public AddDocument(id: string, document: any) {
        document._id = id;

        return this.get(id).then(result => {
            document._rev = result._rev;
            return this.database.put(document);
        }, error => {
            if (error.status == "404") {
                return this.database.put(document, { force: true });
            } else {
                return new Promise((resolve, reject) => {
                    reject(error);
                });
            }
        });
    }

    public Destroy(funcionRep:Function) {
        this.database.destroy().then(response => {
            setTimeout(() => {
                var katios = this.GetIdKatiosLVL1FromSession();
                this.database = new PouchDB("OfflineLog" + katios, { auto_compaction: true });
                funcionRep({"Resp":"OK"});
            }, 2000);
        }).catch(function (err) {
            funcionRep({"Resp":"Error", "Desc":err});
            console.log(err);
        });
    }

    public closeInstance() {
        this.database.close();
    }

    public InstanceAgain() {
        try {
            var katios = this.GetIdKatiosLVL1FromSession();
            this.database = new PouchDB("OfflineLog" + katios, { auto_compaction: true });
        } catch{

        }
    }


    public GetAllDocsDeleted() {
        return this.database.allDocs({ include_docs: true, deleted: true });
    }

    public GetAllDocs() {
        return this.database.allDocs({ include_docs: true });
    }

    public DeleteAllDocs() {
        this.database.allDocs({ include_docs: true }).then(allDocs => {
            return allDocs.rows.filter(row => !row.id.startsWith("CTIVOS")).map(function (row) {
                return { _id: row.id, _rev: row.doc._rev, _deleted: true };
            });
        }).then(deleteDocs => {
            return this.database.bulkDocs(deleteDocs);
        });
    }

    /**
     * Elimina del Log los docs con fecha anterior o igual a {{maxDias}} de la fecha actual
     * Se concatena "  00:00" a la fecha por un error en la funcionalidad de "new Date()"
     * Se utiliza (1000 * 3600 * 24) para calcular el numero de milisegundos en un dÃ­a
     */
    public DeleteOldDocs(maxDias:number) {
        //let maxDias = 3;

        console.debug("DeleteOldDocs")
        this.database.allDocs({ include_docs: true }).then(allDocs => {
            console.debug(allDocs)
            this.AddLogSocket(allDocs);
            allDocs.rows.forEach(element => {
                console.debug(element.doc.Fecha);
                console.debug(element.doc.Fecha.substring(0, 10) + "  00:00")
                console.debug(new Date(element.doc.Fecha.substring(0, 10) + "  00:00"))
                console.debug(Date.now() - new Date(element.doc.Fecha.substring(0, 10) + "  00:00").getTime())
                console.debug((Date.now() - new Date(element.doc.Fecha.substring(0, 10) + "  00:00").getTime()) / (1000 * 3600 * 24))
            });
            return allDocs.rows.filter(row => Math.floor((Date.now() - new Date(row.doc.Fecha.substring(0, 10) + "  00:00").getTime()) / (1000 * 3600 * 24)) >= maxDias)
            .map( row => {
                //Llamar socket. 
                return { _id: row.id, _rev: row.doc._rev, _deleted: true };
            });
        }).then(deleteDocs => {
            
            return this.database.bulkDocs(deleteDocs);
        });
    }


    public AddLogSocket(olM3Procesos: any) {
        try {
            var params: Array<any>;
            params = [{ "nombre": "M3Proceso", "valor": JSON.stringify(olM3Procesos) }];

            this.oM3DevicesService.Device_MPos(this.AddLogSocketOK, params, "LOGM3Procesos", null)
        } catch (ex) {
            console.log(ex);
        }
    }

    public AddLogSocketOK =()=>{

    }


    public Delete(isKey: string) {
        this.database.get(isKey).then(result => {
            return this.database.remove(result);
        });
    }
}